import React from 'react'

export const ProductAttribute = ({
  name,
  value,
  emptyIcon,
  filledIcon,
  maxValue,
  className,
  attributeKeyClasses
}: {
  name?: string
  value?: number | React.ReactElement
  emptyIcon?: React.ReactElement
  filledIcon?: React.ReactElement
  maxValue?: number
  className?: string
  attributeKeyClasses?: string
}) => {
  const MAX_VALUE = maxValue ?? 5
  const ValueIndicator = ({ filled = false }: { filled: boolean }) => (
    <svg
      className={className}
      stroke='black'
      strokeWidth='1px'
      width='11px'
      height='10px'
      version='1.1'
      id='Ebene_1'
      x='0px'
      y='0px'
      viewBox='0 0 24 24'
    >
      {filled
        ? (filledIcon && <>{filledIcon}</>) || (
            <g>
              <polygon points='12,1.92 3.12,6.96 3.12,17.04 12,22.08 20.88,17.04 20.88,6.96' />
            </g>
          )
        : (emptyIcon && <>{emptyIcon}</>) || (
            <g>
              <path d='M12,22.08l-8.88-5.03V6.96L12,1.92l8.88,5.04v10.08L12,22.08z M4.12,16.46L12,20.92l7.88-4.47V7.54L12,3.08L4.12,7.54 V16.46z' />
            </g>
          )}
    </svg>
  )

  if (!name || !value) return <></>

  return (
    <div className='flex h-11 items-center justify-between border-b border-black'>
      <p
        className={`text-10 leading-12 tracking-3 my-auto h-fit uppercase ${attributeKeyClasses}`}
      >
        {name}:
      </p>
      <div className='my-auto flex w-fit'>
        {Number.isInteger(value)
          ? Array(MAX_VALUE)
              .fill(0)
              .map((_, idx) => (
                <ValueIndicator key={idx} filled={idx + 1 <= value} />
              ))
          : value}
      </div>
    </div>
  )
}
